// extracted by mini-css-extract-plugin
export default {"w-full":"Image_w-full__SkZyp","deleteButton":"Image_deleteButton__PiTQh"};